import styled from "styled-components";
import { statusColors } from "./statusPalette";
import { BOTTOM_TOAST_Z_INDEX } from "./config";

export const TabBarWrapper = styled.div`
  background: rgb(244, 246, 251);
`;

export const Screen = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
`;

export const ScrollList = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 13px;
  background: ${(props) => (props.active ? "#FFF5F6" : "#ffffff")};
  color: #293142;
  border: 1px solid ${(props) => (props.active ? "#EF4F5F" : "#E5E7EB")};
  cursor: pointer;
  white-space: nowrap;
`;

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 12px;
`;

export const CountText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #212121;
`;

export const AdviceLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  border: none;
  background: transparent;
  color: #e23744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  span {
    text-decoration: underline dotted;
    text-underline-offset: 4px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #ffffff;
  position: relative;
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};

  &::after {
    content: "";
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 0;
    border-bottom: 1px dashed #d5d8de;
  }

  &:last-child::after {
    border-bottom: none;
  }
`;

export const RowIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > img {
    width: 100%;
    height: 100%;
  }
`;

export const RowBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RowTitle = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #212121;
`;

export const RowSubtitle = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: #9197a6;
  display: flex;
  align-items: center;
  gap: 6px;
`;

// UTR line on a payment row: smaller and greyer than the other subtitles.
export const UtrSubtitle = styled(RowSubtitle)`
  font-size: 12px;
  line-height: 14px;
  color: #767c8f;
  gap: 8px;
`;

// Short message pinned to the bottom of the screen, above the sheet and drawer overlays.
export const BottomToast = styled.div`
  position: fixed;
  left: 50%;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  z-index: ${BOTTOM_TOAST_Z_INDEX};
  padding: 10px 16px;
  border-radius: 8px;
  background: #293142;
  color: #ffffff;
  font-size: 13px;
  line-height: 16px;
  white-space: nowrap;
  box-shadow: 0px 2px 8px rgba(28, 28, 28, 0.2);
`;

export const CopyButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #596378;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  line-height: 1;

  &:hover {
    color: #212121;
  }
`;

export const RowRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

export const Amount = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #212121;
`;

export const StatusPill = styled.div`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: ${(props) => statusColors(props.status).bg};
  color: ${(props) => statusColors(props.status).fg};
`;

export const DateChipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const SheetOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const Sheet = styled.div`
  width: 100%;
  max-width: 480px;
  background: #f6f6fa;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 28px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: slideUp 0.2s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SheetTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #212121;
`;

export const SheetCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  font-size: 20px;
  line-height: 1;
  color: #596378;
  cursor: pointer;
`;

export const OptionsCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 4px 16px;
`;

export const OptionRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 0;
  border-bottom: 1px dashed #e5e7eb;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const OptionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OptionLabel = styled.div`
  font-size: 15px;
  color: #212121;
`;

export const RadioOuter = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.active ? "#EF4F5F" : "#EF4F5F")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const RadioInner = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => (props.active ? "#EF4F5F" : "transparent")};
`;

export const CustomDateRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
`;

export const DateField = styled.label`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
`;

export const DateFieldTitle = styled.span`
  font-size: 11px;
  color: #9197a6;
`;

export const DateFieldInput = styled.input`
  border: none;
  outline: none;
  padding: 2px 0 0;
  font-size: 14px;
  color: #212121;
  background: transparent;
  width: 100%;

  &::-webkit-calendar-picker-indicator {
    filter: invert(45%) sepia(85%) saturate(2500%) hue-rotate(330deg)
      brightness(95%) contrast(90%);
    cursor: pointer;
  }
`;

export const ApplyButton = styled.button`
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  background: #ef4f5f;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 16px;
  color: #9197a6;
  font-size: 14px;
`;

export const HeaderGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
`;

export const HeaderBackWrap = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin-right: 0 !important;
    background: #f4f6fb;
  }
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const HeaderSubtitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 14px;
  color: #767c8f;
`;

export const HeaderTitle = styled.div`
  font-family: "OurLexend-SemiBold", Helvetica, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #293142;
`;

export const HeaderIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0.9px solid #e6e9ef;
  border-radius: 90px;
  background: #f4f6fb;
  cursor: pointer;
`;

export const SearchBar = styled.form`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const SearchField = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
  height: 44px;
  padding: 12px 16px 12px 12px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 80px;
`;

export const SearchBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  line-height: 20px;
  color: #293142;

  &::placeholder {
    color: #9197a6;
  }
`;
